module.exports = __webpack_public_path__ + "img/36.2b186d74.png";